import { render, staticRenderFns } from "./Scheduler.vue?vue&type=template&id=b89155a2"
import script from "./Scheduler.vue?vue&type=script&lang=js"
export * from "./Scheduler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports